import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["source"]
  static values = { 
    text: String,
    successMessage: String,
    errorMessage: String
  }

  connect() {
    // Set default messages if not provided
    if (!this.successMessageValue) {
      this.successMessageValue = "Copied to clipboard!"
    }
    if (!this.errorMessageValue) {
      this.errorMessageValue = "Could not copy to clipboard"
    }
  }

  copy(event) {
    event.preventDefault()
    
    // Get text to copy - either from data-clipboard-text-value or from target element
    const textToCopy = this.textValue || this.getTextFromTarget()
    
    if (!textToCopy) {
      console.error("No text to copy")
      return
    }

    // Try modern clipboard API first
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          this.showSuccess()
        })
        .catch((err) => {
          console.error("Clipboard API failed:", err)
          this.fallbackCopy(textToCopy)
        })
    } else {
      // Use fallback for older browsers or non-secure contexts
      this.fallbackCopy(textToCopy)
    }
  }

  getTextFromTarget() {
    if (this.hasSourceTarget) {
      return this.sourceTarget.textContent.trim()
    }
    return null
  }

  fallbackCopy(text) {
    try {
      const textArea = document.createElement("textarea")
      textArea.value = text
      textArea.style.position = "fixed"
      textArea.style.opacity = "0"
      document.body.appendChild(textArea)
      textArea.select()
      textArea.setSelectionRange(0, 99999) // For mobile devices
      
      const successful = document.execCommand("copy")
      document.body.removeChild(textArea)
      
      if (successful) {
        this.showSuccess()
      } else {
        this.showError()
      }
    } catch (err) {
      console.error("Fallback copy failed:", err)
      this.showError()
    }
  }

  showSuccess() {
    // You can customize this to use your app's notification system
    // For now, using alert but could be replaced with toast notifications
    alert(this.successMessageValue)
  }

  showError() {
    alert(this.errorMessageValue)
  }
}
